import api from './api';

const serviceProvidersService = {
  // Get all service providers
  getServiceProviders: async () => {
    const response = await api.get('/service-providers');
    return response.data;
  },

  // Get single service provider
  getServiceProvider: async (id) => {
    const response = await api.get(`/service-providers/${id}`);
    return response.data;
  },

  // Create service provider
  createServiceProvider: async (data) => {
    const response = await api.post('/service-providers', data);
    return response.data;
  },

  // Update service provider
  updateServiceProvider: async (id, data) => {
    const response = await api.put(`/service-providers/${id}`, data);
    return response.data;
  },

  // Delete service provider
  deleteServiceProvider: async (id) => {
    const response = await api.delete(`/service-providers/${id}`);
    return response.data;
  }
};

export default serviceProvidersService; 